import { tokens } from '@cast/design-system';

import { WorkloadsSummaryMetricsChartDataKey } from './_types';

export const chartDataSettings: Record<
  WorkloadsSummaryMetricsChartDataKey,
  {
    color: string;
    title: string;
    tooltipTitle: string;
    dashed?: boolean;
    tooltipText?: string;
  }
> = {
  originalReq: {
    color: tokens.theme.data.grey400,
    title: 'ORIGINAL REQUESTS',
    tooltipTitle: 'Original requests',
  },
  req: {
    color: tokens.theme.data.blue300,
    title: 'REQUESTED',
    tooltipTitle: 'Requested',
    tooltipText:
      'Average CPU/memory requested by containers across the selected time range.',
  },
  rec: {
    color: tokens.theme.data.grey900,
    title: 'RECOMMENDED',
    tooltipTitle: 'Recommended',
    dashed: true,
  },
  usage: {
    color: tokens.theme.data.green300,
    title: 'USED',
    tooltipTitle: 'Used',
    tooltipText:
      'Average CPU/memory actually consumed by containers across the selected time range.',
  },
};
